import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { UsuarioBeneficioGerenciarCartoesService } from 'src/app/services/usuario-beneficio-gerenciar-cartoes.service';
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { LoadingGenericoComponent } from '../../components/loading-generico/loading-generico.component';
import { AlertConcluidoComponent } from '../../components/alert-concluido/alert-concluido.component';
import { AlertErroComponent } from '../../components/alert-erro/alert-erro.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { SelectComponent } from '../../components/select/select.component';
import { NgClass } from '@angular/common';
import { ApiStateComponent } from '../../components/api-state/api-state.component';
import { FooterComponent } from '../../components/footer/footer.component';

@Component({
    selector: 'app-usuario-beneficio-gerenciar-cartoes',
    templateUrl: './usuario-beneficio-gerenciar-cartoes.component.html',
    styleUrls: ['./usuario-beneficio-gerenciar-cartoes.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, BotaoChatComponent, LoadingGenericoComponent, AlertConcluidoComponent, AlertErroComponent, BreadcrumbComponent, FormsModule, ReactiveFormsModule, SelectComponent, NgClass, ApiStateComponent, FooterComponent]
})
export class UsuarioBeneficioGerenciarCartoesComponent implements OnInit {

  // URL
  private idUsuario: any;
  private idProduto: any;

  // FORM
  solicitacaoForm: UntypedFormGroup;

  // DADOS SEGUNDA VIA
  public descricaoProduto: string;
  public dataEmissao: Date;
  public listaTipoSolicitacao: any;
  public numeroCartao: number;
  public numeroCartaoSPTRANS: number;
  // LISTA HISTORICO OCORRENCIAS
  public listaHistoricoOcorrencias: any = null;

  // SITUACAO API
  public loading: boolean = false;
  public dadosSegundaViaCartaoApi: boolean = null;
  public historicoSolicitacaoApi: boolean = null;
  public concluirSolicitacaoApi: boolean = null;

  // ALERTAS
  public alertConcluidoMensagem: string;
  public alertErroMensagem: string;

  constructor(
    private readonly service: UsuarioBeneficioGerenciarCartoesService,
    public activatedRoute: ActivatedRoute,
    private readonly formularioBuilder: UntypedFormBuilder,
    public rota: Router,
    ) {
      this.construirFormulario();
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
        this.idUsuario = params.idUsuario;
        this.idProduto = params.idProduto;
        this.getDadosSegundaViaCartao();
        this.getHistoricoOcorrenciasCartoes();
      }
    );

  }

  construirFormulario() {
    this.solicitacaoForm = this.formularioBuilder.group({
      tipoSolicitacao: [null, Validators.compose([ Validators.required])],
      observacoes: ['', Validators.compose([ Validators.required, Validators.minLength(2) ])],
    })
  }

  getDadosSegundaViaCartao() {
    this.service.getDadosSegundaViaCartao(this.idUsuario, this.idProduto)
    .pipe(take(1))
    .subscribe({
      next: (resposta: any) => {
        if (resposta.status === 'OK') {
          this.descricaoProduto = resposta.response.descricaoProduto;
          this.dataEmissao = resposta.response.dataEmissao;
          this.listaTipoSolicitacao = resposta.response.tiposOcorrencia;
          this.numeroCartao = resposta.response.numeroCartao;
          this.numeroCartaoSPTRANS = resposta.response.numeroCartaoSPTRANS;
          this.dadosSegundaViaCartaoApi = true;
        } else {
          this.dadosSegundaViaCartaoApi = false;
        }
      },
      error: (error: any) => {
        console.error(error);
        this.dadosSegundaViaCartaoApi = false;
      }
    });
  }

  concluirSolicitacao() {
    let body: any =
    {
      "idEmpresa": Number.parseInt(localStorage.idEmpresaLogada),
      "idProduto": Number.parseInt(this.idProduto),
      "idTipoOcorrencia": Number.parseInt(this.solicitacaoForm.value.tipoSolicitacao),
      "idUsuario": Number.parseInt(this.idUsuario),
      "numeroCartao": this.numeroCartao,
      "numeroCartaoSPTRANS": this.numeroCartaoSPTRANS,
      "observacoes": this.solicitacaoForm.value.observacoes
    }

    this.loading = true;

    this.service.concluirSolicitacao(body).pipe(take(1))
    .subscribe({
      next: (resposta: any) => {
        if (resposta.status === 'OK') {
          this.alertConcluidoMensagem = resposta.mensagem;
          this.construirFormulario();
          this.concluirSolicitacaoApi = true;
        } else {
          this.alertErroMensagem = resposta.mensagem;
          this.concluirSolicitacaoApi = false;
        }
        this.loading = false;
      },
      error: (error: any) => {
        console.error(error);
        this.alertErroMensagem = error.error.mensagem ?? 'Erro ao realizar solicitação de 2ª via';
        this.concluirSolicitacaoApi = false;
        this.loading = false;
      }
    });
  }

  getHistoricoOcorrenciasCartoes() {
    this.service.getHistoricoOcorrenciasCartoes(this.idUsuario, this.idProduto).pipe(take(1))
    .subscribe({
      next: (resposta: any) => {
        if (resposta.status === 'OK' && resposta.response?.length) {
          this.listaHistoricoOcorrencias = resposta.response;
          this.historicoSolicitacaoApi = true;
        } else {
          this.listaHistoricoOcorrencias = undefined;
          this.historicoSolicitacaoApi = undefined;
        }
      },
      error: (error: any) => {
        console.error(error);
        this.historicoSolicitacaoApi = false;
        this.listaHistoricoOcorrencias = false;
      }
    });
  }

  // Alerta de sucesso: atualiza histórico e redireciona para outra tela
  eventoAlertConcluido(event: any){
    this.getHistoricoOcorrenciasCartoes();
    this.concluirSolicitacaoApi = null;
    this.rota.navigate(['dados-usuario'], { queryParams : { idUsuario : this.idUsuario }});
  }

  eventoAlertErro(event: any){
    this.concluirSolicitacaoApi = null;
  }

  goBackPage() {
    window.history.back();
  }
}
